import { createUseStyles } from 'react-jss'
import Color from 'color'

import config from 'styles/config'
import { boldFont, textSize } from '@portal/kit/pkg/styles'

const ranRoomCardStyles = createUseStyles(theme => ({
  credentials: {
    borderRadius: 6,
    color: theme.main_color,
    backgroundColor: Color(theme.main_color).alpha(.12).rgb().toString(),
    textAlign: 'right',
  },
  credentialsItem: {
    padding: '8px 16px',
    borderBottom: `1px solid ${Color(theme.main_color).alpha(.12).rgb().toString()}`,

    '&:last-child': {
      borderBottom: 'none',
    }
  },
  credentialsLabel: {
    float: 'left',
    paddingRight: 10,
    ...textSize(14, 19)
  },
  credentialsValue: {
    ...boldFont(),
    ...textSize(16, 19)
  },
  [config.mediaQueries.tabletPortrait]: {
    credentialsValue: {
      whiteSpace: 'nowrap',
    },
  }
}))

export default ranRoomCardStyles
